<template>
  <div class="home-wrap">
    <HomeHeader />
    <QuestionPopup />
    <CarouselList />
    <HomeInfo />
    <HomeNews />
    <VFooter />
  </div>
</template>

<script>
import VFooter from "@/components/footer/VFooter";
import HomeInfo from "./components0901/HomeInfo.vue";
import HomeNews from "./components0901/HomeNews.vue";
import HomeHeader from "./components0901/HomeHeader.vue";
import CarouselList from "./components0901/CarouselList.vue";
import QuestionPopup from "@/components/QuestionPopup/index.vue";

export default {
  components: {
    VFooter,
    HomeInfo,
    HomeNews,
    HomeHeader,
    CarouselList,
    QuestionPopup
  },
  name: "home",
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.home-wrap {
  position: relative;
  background: #f5f6f7;
}
</style>
